/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * DocumentMappedStatus
 * Унифицированный статус документа, в который WMS маппит свой raw_status.
 */
export enum DocumentMappedStatus {
  Planned = "planned",
  Picking = "picking",
  Assembled = "assembled",
  Shipped = "shipped",
  Cancelled = "cancelled",
}

/** DocumentKind */
export enum DocumentKind {
  Shipment = "shipment",
  Receipt = "receipt",
}

/** AddressProvider */
export enum AddressProvider {
  Google = "google",
  Mapbox = "mapbox",
  Dadata = "dadata",
}

/** AddressForValidationSchema */
export interface AddressForValidationSchema {
  provider: AddressProvider;
  /** Provider Address Uid */
  provider_address_uid: string;
  /** Street Name */
  street_name: string;
  /** Street Number */
  street_number: string | null;
  /** Place Name */
  place_name: string | null;
}

/** ContextSchema */
export interface ContextSchema {
  scope: ContextScopeSchema;
}

/** ContextScopeSchema */
export interface ContextScopeSchema {
  /** ScopePermissions */
  $permissions: {
    /** Create Warehouses */
    create_warehouses?: boolean;
    /** Manage Epd */
    manage_epd?: boolean;
    /** View Warehouses */
    view_warehouses?: boolean;
  };
}

/** CreateWarehouseSchema */
export interface CreateWarehouseSchema {
  /** Name */
  name: string;
  /**
   * Customer Scope Id
   * Пространство заказчика, у которого провайдер заводит склад
   */
  customer_scope_id: number;
  address: AddressForValidationSchema;
  /** Epd Enabled */
  epd_enabled?: boolean;
}

/** DocumentFilterOptionSchema */
export interface DocumentFilterOptionSchema {
  /** Value */
  value: string;
  /** Label */
  label: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** ImageVariant */
export interface ImageVariant {
  /** Url */
  url: string;
}

/** ImportErrorCode */
export type ImportErrorCode = "DUPLICATE_CODE_IN_WAREHOUSE";

/** ReceiptDocumentListItemSchema */
export interface ReceiptDocumentListItemSchema {
  /** Uid */
  uid: string;
  /** External Uid */
  external_uid: string;
  /** Warehouse Uid */
  warehouse_uid: string;
  /** Number */
  number?: string | null;
  mapped_status?: DocumentMappedStatus | null;
  /** Raw Status */
  raw_status?: string | null;
  /** Dt Document */
  dt_document?: string | null;
  /** Sender */
  sender?: string | null;
  /** Recipient */
  recipient?: string | null;
  /** Weight */
  weight?: string | null;
  /** Volume */
  volume?: string | null;
  /** Places */
  places?: WarehouseDocumentPlaceSchema[] | null;
  /**
   * Kind
   * @default "receipt"
   */
  kind?: "receipt";
  /** Purchase Order Number */
  purchase_order_number?: string | null;
  /** Dt Planned Delivery */
  dt_planned_delivery?: string | null;
  /** Dt Actual Delivery */
  dt_actual_delivery?: string | null;
  /** Dt Placement */
  dt_placement?: string | null;
}

/** ReceiptDocumentSchema */
export interface ReceiptDocumentSchema {
  /** Uid */
  uid: string;
  /** External Uid */
  external_uid: string;
  /** Warehouse Uid */
  warehouse_uid: string;
  /** Number */
  number?: string | null;
  mapped_status?: DocumentMappedStatus | null;
  /** Raw Status */
  raw_status?: string | null;
  /** Dt Document */
  dt_document?: string | null;
  /** Sender */
  sender?: string | null;
  /** Recipient */
  recipient?: string | null;
  /** Weight */
  weight?: string | null;
  /** Volume */
  volume?: string | null;
  /** Places */
  places?: WarehouseDocumentPlaceSchema[] | null;
  /**
   * Kind
   * @default "receipt"
   */
  kind?: "receipt";
  /** Purchase Order Number */
  purchase_order_number?: string | null;
  /** Dt Planned Delivery */
  dt_planned_delivery?: string | null;
  /** Dt Actual Delivery */
  dt_actual_delivery?: string | null;
  /** Dt Placement */
  dt_placement?: string | null;
  /** Items */
  items?: WarehouseDocumentItemSchema[];
  /** Files */
  files?: WarehouseDocumentFileSchema[];
}

/** RecordsListGenericSchema[Annotated[Union[ShipmentDocumentListItemSchema, ReceiptDocumentListItemSchema], FieldInfo(annotation=NoneType, required=True, discriminator='kind')]] */
export interface RecordsListGenericSchemaAnnotatedUnionShipmentDocumentListItemSchemaReceiptDocumentListItemSchemaFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorKind {
  /** Items */
  items: (ShipmentDocumentListItemSchema | ReceiptDocumentListItemSchema)[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveWarehouseSchema] */
export interface RecordsListGenericSchemaRetrieveWarehouseSchema {
  /** Items */
  items: RetrieveWarehouseSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RecordsListGenericSchema[RetrieveWarehouseSkuSchema] */
export interface RecordsListGenericSchemaRetrieveWarehouseSkuSchema {
  /** Items */
  items: RetrieveWarehouseSkuSchema[];
  /**
   * Total
   * @default 0
   */
  total?: number;
}

/** RetrieveWarehouseSchema */
export interface RetrieveWarehouseSchema {
  /** Uid */
  uid: string;
  /** Name */
  name: string;
  customer: WarehouseCustomerSchema;
  /**
   * Is Active
   * @default false
   */
  is_active?: boolean;
  /** Deactivated At */
  deactivated_at?: string | null;
  /** Legal Entity Uid */
  legal_entity_uid?: string | null;
  address?: WarehouseAddress | null;
  /** Epd Enabled */
  epd_enabled?: boolean;
  /** WarehousePermissions */
  $permissions: {
    /** View */
    view?: boolean;
    /** View Settings */
    view_settings?: boolean;
    /** Update */
    update?: boolean;
    /** Activate */
    activate?: boolean;
    /** Deactivate */
    deactivate?: boolean;
    /** Reactivate */
    reactivate?: boolean;
  };
}

/** RetrieveWarehouseSettingsSchema */
export interface RetrieveWarehouseSettingsSchema {
  /** Api Key */
  api_key: string;
  /** Api Url */
  api_url: string;
}

/** RetrieveWarehouseSkuSchema */
export interface RetrieveWarehouseSkuSchema {
  /** Uid */
  uid: string;
  /** Ref Id */
  ref_id: string;
  /** Title */
  title: string | null;
  /** Code */
  code: string | null;
  /** Product Uid */
  product_uid: string | null;
  /** Available Stock */
  available_stock: number;
  import_error_code: ImportErrorCode | null;
  /** Dt Updated */
  dt_updated: string | null;
}

/** ShipmentDocumentListItemSchema */
export interface ShipmentDocumentListItemSchema {
  /** Uid */
  uid: string;
  /** External Uid */
  external_uid: string;
  /** Warehouse Uid */
  warehouse_uid: string;
  /** Number */
  number?: string | null;
  mapped_status?: DocumentMappedStatus | null;
  /** Raw Status */
  raw_status?: string | null;
  /** Dt Document */
  dt_document?: string | null;
  /** Sender */
  sender?: string | null;
  /** Recipient */
  recipient?: string | null;
  /** Weight */
  weight?: string | null;
  /** Volume */
  volume?: string | null;
  /** Places */
  places?: WarehouseDocumentPlaceSchema[] | null;
  /**
   * Kind
   * @default "shipment"
   */
  kind?: "shipment";
}

/** ShipmentDocumentSchema */
export interface ShipmentDocumentSchema {
  /** Uid */
  uid: string;
  /** External Uid */
  external_uid: string;
  /** Warehouse Uid */
  warehouse_uid: string;
  /** Number */
  number?: string | null;
  mapped_status?: DocumentMappedStatus | null;
  /** Raw Status */
  raw_status?: string | null;
  /** Dt Document */
  dt_document?: string | null;
  /** Sender */
  sender?: string | null;
  /** Recipient */
  recipient?: string | null;
  /** Weight */
  weight?: string | null;
  /** Volume */
  volume?: string | null;
  /** Places */
  places?: WarehouseDocumentPlaceSchema[] | null;
  /**
   * Kind
   * @default "shipment"
   */
  kind?: "shipment";
  /** Items */
  items?: WarehouseDocumentItemSchema[];
  /** Files */
  files?: WarehouseDocumentFileSchema[];
  /** Order Uid */
  order_uid?: string | null;
}

/** UpdateWarehouseSchema */
export interface UpdateWarehouseSchema {
  /** Name */
  name: string;
  address?: AddressForValidationSchema | null;
  /** Epd Enabled */
  epd_enabled?: boolean | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/**
 * WarehouseAddress
 * Физический адрес склада = адрес погрузки в ЭТрН.
 */
export interface WarehouseAddress {
  /** Uid */
  uid: string;
  provider: AddressProvider;
  /** Provider Address Uid */
  provider_address_uid: string;
  /** As String */
  as_string: string;
  /** Country Iso Code */
  country_iso_code: string;
  /** Country Name */
  country_name: string;
  /** Postal Code */
  postal_code: string;
  /** Region Name */
  region_name: string;
  /** City Name */
  city_name: string;
  /** Street Name */
  street_name: string;
  /** Street Number */
  street_number?: string | null;
  /** Place Name */
  place_name?: string | null;
  /** Lat */
  lat?: number | null;
  /** Lon */
  lon?: number | null;
}

/** WarehouseCustomerSchema */
export interface WarehouseCustomerSchema {
  /** Id */
  id: number;
  /** Title */
  title: string;
}

/**
 * WarehouseDocumentFileSchema
 * Файл-вложение документа в response detail-эндпоинта. Отдаются только synced-файлы.
 */
export interface WarehouseDocumentFileSchema {
  /** Name */
  name: string;
  /** Kind */
  kind?: string | null;
  /** Ext */
  ext?: string | null;
  variants: WarehouseDocumentFileVariantsSchema;
}

/** WarehouseDocumentFileVariantsSchema */
export interface WarehouseDocumentFileVariantsSchema {
  thumbnail?: ImageVariant | null;
  fullscreen?: ImageVariant | null;
  file?: ImageVariant | null;
}

/**
 * WarehouseDocumentItemSchema
 * Строка документа. Quantity-поля заполняются в зависимости от kind:
 * - shipment: quantity_plan / quantity_picked / quantity_shipped;
 * - receipt:  quantity_plan / quantity_fact / multiplicity.
 */
export interface WarehouseDocumentItemSchema {
  /** Product Ref Uid */
  product_ref_uid?: string | null;
  /** Product Uid */
  product_uid?: string | null;
  /** Name */
  name: string;
  /** Quantity Plan */
  quantity_plan?: string | null;
  /** Quantity Picked */
  quantity_picked?: string | null;
  /** Quantity Shipped */
  quantity_shipped?: string | null;
  /** Quantity Fact */
  quantity_fact?: string | null;
  /** Multiplicity */
  multiplicity?: string | null;
  /** Price */
  price?: string | null;
}

/**
 * WarehouseDocumentPlaceSchema
 * Одно «место» в документе: тип (палет/коробка/...) и количество.
 */
export interface WarehouseDocumentPlaceSchema {
  /** Type */
  type: string;
  /** Amount */
  amount: number;
}

/** WarehouseImportErrorsCountSchema */
export interface WarehouseImportErrorsCountSchema {
  /** Count */
  count: number;
}
